import React, { useState } from 'react';
import { Header } from '../components/heylloyd/Header';
import { HeroSection } from '../components/heylloyd/HeroSection';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { FinalCTA } from '../components/heylloyd/FinalCTA';
import { Download, Monitor, Bot, Check, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HeyLloydPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-cyan-100 selection:text-cyan-900" data-id="element-2282">
      <Header data-id="element-2283" />
      <div id="hero" data-id="element-2284">
        <HeroSection data-id="element-2285" />
      </div>
      {/* PASO 1 */}
      <div id="paso-1" data-id="element-2286">
        <StepSection stepNumber="1" title="Instala y abre HeyLloyd en tu computadora" data-id="element-2287">
          <p className="text-lg md:text-xl text-slate-600 mb-6 md:mb-8" data-id="element-2288">
            Primero, vamos a convertir tu computadora en una computadora con IA
            integrada. Sigue estos pasos sencillos:
          </p>
          <div className="mb-8 md:mb-10" data-id="element-2289">
            <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" data-id="element-2290">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<Download className="w-5 h-5" data-id="element-2292" />} data-id="element-2291">
                Descargar HeyLloyd
              </Button>
            </a>
          </div>
          <div className="space-y-4 md:space-y-6" data-id="element-2293">
            <div className="flex gap-3 md:gap-4" data-id="element-2294">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2295">
                1
              </div>
              <div data-id="element-2296">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2297">
                  Haz clic en "Get for Mac" o "Get for Windows"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2298">
                  Esto descargará el archivo de instalación de HeyLloyd en tu
                  computadora (normalmente en la carpeta "Descargas").
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2299">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2300">
                2
              </div>
              <div data-id="element-2301">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2302">
                  Abre el archivo descargado
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2303">
                  Haz doble clic en el archivo. Se abrirá el instalador de
                  HeyLloyd. Sigue las instrucciones en pantalla hasta que
                  termine.
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2304">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2305">
                3
              </div>
              <div data-id="element-2306">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2307">
                  Haz clic en "Start Lloyd"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2308">
                  Cuando la instalación finalice, selecciona "Start Lloyd".
                  Verás una capa transparente sobre tu pantalla: ese es
                  HeyLloyd, listo para ayudarte.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 md:mt-8 p-3 md:p-4 bg-blue-50 border border-blue-100 rounded-lg text-blue-800 text-xs md:text-sm" data-id="element-2309">
            <strong data-id="element-2310">Nota:</strong> Si en algún momento te pierdes, vuelve al
            video de arriba y mira exactamente cómo lo hago en mi pantalla.
          </div>
        </StepSection>
      </div>
      {/* PASO 2 */}
      <div id="paso-2" data-id="element-2311">
        <StepSection stepNumber="2" title="Usa HeyLloyd mientras trabajas" bgColor="gray" data-id="element-2312">
          <p className="text-lg md:text-xl text-slate-600 mb-4 md:mb-6" data-id="element-2313">
            HeyLloyd es una superposición de escritorio transparente que se
            coloca sobre tu pantalla. Eso significa que:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-2314">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2315">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2316" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2317">
                Tu pantalla de siempre
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2318">
                Ves tu computadora como siempre, pero ahora con IA integrada.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2319">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2320" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2321">
                Contexto automático
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2322">
                HeyLloyd ve lo que tú ves, entiende el contexto y te ayuda sin
                que tengas que cambiar de pestaña.
              </p>
            </div>
          </div>
          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-2323">
            {['Abre cualquier aplicación o página donde estés trabajando.', 'Activa HeyLloyd (como viste en el video).', 'Pídele lo que necesites: HeyLloyd ya entiende qué hay en tu pantalla.'].map((item, i) => <li key={i} className="flex items-start text-slate-700 text-sm md:text-base" data-id="element-2324">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-cyan-500 mr-2 md:mr-3 flex-shrink-0 mt-0.5" data-id="element-2325" />
                <span data-id="element-2326">{item}</span>
              </li>)}
          </ul>
          <p className="font-medium text-slate-900 italic border-l-4 border-cyan-500 pl-3 md:pl-4 text-sm md:text-base" data-id="element-2327">
            "Piensa en HeyLloyd como la capa de IA que le faltaba a tu
            computadora."
          </p>
        </StepSection>
      </div>
      {/* PASO 3 */}
      <div id="paso-3" data-id="element-2328">
        <StepSection stepNumber="3" title="Elige y usa tus Lloyds personalizados" data-id="element-2329">
          <p className="text-slate-600 mb-4 md:mb-6 text-sm md:text-base" data-id="element-2330">
            Dentro de HeyLloyd puedes usar <strong data-id="element-2331">Custom Lloyds</strong>: son
            bots especializados para tareas concretas (copy, investigación,
            etc.). Cada Lloyd está pre-configurado para guiarte paso a paso.
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-2332">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-2333">
              Cómo funciona:
            </h4>
            <ol className="list-decimal list-inside space-y-1.5 md:space-y-2 text-slate-700 text-sm md:text-base" data-id="element-2334">
              <li data-id="element-2335">Descargas un archivo de Lloyd en tu computadora.</li>
              <li data-id="element-2336">Abres ese archivo con HeyLloyd.</li>
              <li data-id="element-2337">
                HeyLloyd carga ese bot y empieza a darte instrucciones claras.
              </li>
            </ol>
          </div>
          <div className="space-y-1.5 md:space-y-2" data-id="element-2338">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-2339">
              Beneficios:
            </h4>
            <ul className="space-y-1.5 md:space-y-2 text-slate-600 text-sm md:text-base" data-id="element-2340">
              <li className="flex items-center" data-id="element-2341">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2342" />
                No tienes que saber de prompts.
              </li>
              <li className="flex items-center" data-id="element-2343">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2344" />
                No tienes que diseñar nada desde cero.
              </li>
              <li className="flex items-center" data-id="element-2345">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2346" />
                Solo eliges, abres y sigues las indicaciones.
              </li>
            </ul>
          </div>
        </StepSection>
      </div>
      {/* GALLERY */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-2347">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-2348">
          <div className="text-center mb-10 md:mb-16" data-id="element-2349">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-2350">
              Descarga tu Lloyd y empieza ahora
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-2351">
              Haz clic en la imagen para descargar el Lloyd que quieras usar,
              luego ábrelo desde HeyLloyd.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-2352">
            <LloydCard title="AI Product Builder" subtitle="Construcción de productos con IA" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento, ayudándote a construir productos profesionales sin experiencia técnica." imageSrc="https://cdn.magicpatterns.com/uploads/pXDmn28qLnCMrUYkdpGPpS/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://app.heylloyd.io/share/lloyd/2b44866d-5ed" badge="FREE - Value $97" data-id="element-2353" />
            <LloydCard title="Ebook Writer" subtitle="Escritura de ebooks" description="Perfecto para crear ebooks completos desde cero. HeyLloyd te guiará en la estructura, capítulos, y contenido para que escribas tu ebook paso a paso, directamente en tu pantalla." imageSrc="https://cdn.magicpatterns.com/uploads/mZHQRarDkUFPHSnnRgrYNx/heylloyd-image-1768596398723.png" url="https://app.heylloyd.io/share/lloyd/39ad06ee-508" badge="FREE - Value $97" data-id="element-2354" />
            <LloydCard title="Ebook Cover Designer" subtitle="Diseño de portadas" description="Especializado en crear portadas profesionales y atractivas para tus ebooks. HeyLloyd te guía en el diseño visual, tipografía y elementos gráficos para que tu ebook destaque y atraiga lectores." imageSrc="https://cdn.magicpatterns.com/uploads/95YcbtScePy8FYnqxtUWrb/hf_20260116_225742_c84c2966-04d0-407a-8eb3-53f8e6f29bab.png" url="https://app.heylloyd.io/share/lloyd/81dd7839-af7" badge="FREE - Value $97" data-id="element-2355" />
            <LloydCard title="Identity Persuasion Copywriter" subtitle="Copy persuasivo" description="Especializado en crear copy que conecta con la identidad de tu audiencia. Ideal para escribir mensajes que persuaden, venden y generan conversiones con técnicas de copywriting avanzadas." imageSrc="https://cdn.magicpatterns.com/uploads/mSU1vsY4XXAQMJDxHLq9tK/heylloyd-image-1768596505790.png" url="https://app.heylloyd.io/share/lloyd/7444c6ee-43c" badge="FREE - Value $97" data-id="element-2356" />
            <LloydCard title="Sales Letter Weapon" subtitle="Cartas de ventas" description="Tu arma secreta para crear sales letters que convierten. HeyLloyd te ayudará a estructurar y escribir cartas de ventas persuasivas que generan resultados reales." imageSrc="https://cdn.magicpatterns.com/uploads/5Vbgxv8pJwQBoVv72Jwat3/heylloyd-image-1768596561791.png" url="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" badge="FREE - Value $97" data-id="element-2357" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="Optimización de anuncios" description="Motor de decisiones para tus campañas de Meta Ads. HeyLloyd te ayuda a analizar, optimizar y tomar decisiones estratégicas sobre tus anuncios de Facebook e Instagram en tiempo real." imageSrc="https://cdn.magicpatterns.com/uploads/uX7GKZjLzcZHYruWJanCH7/heylloyd-image-1768596648758.png" url="https://app.heylloyd.io/share/lloyd/197ee0e2-22a" badge="FREE - Value $97" data-id="element-2358" />
            <LloydCard title="The Viral PDF Lab" subtitle="PDFs virales" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets, recursos descargables y contenido que tu audiencia querrá compartir una y otra vez." imageSrc="https://cdn.magicpatterns.com/uploads/wRK7DAN3h4pP5mk1SskSzS/heylloyd-image-1768596692126.png" url="https://app.heylloyd.io/share/lloyd/8d17c3a4-d2c" badge="FREE - Value $97" data-id="element-2359" />
            <LloydCard title="AI Complete Brand Operation System" subtitle="Sistema de marca completo" description="Sistema operativo completo para tu marca con IA. Desde estrategia hasta ejecución, HeyLloyd te guía en todos los aspectos de construcción y operación de tu marca de forma integrada." imageSrc="https://cdn.magicpatterns.com/uploads/i1MwR9sTfLGqX1o8cqMy9E/heylloyd-image-1768596733993.png" url="https://app.heylloyd.io/share/lloyd/6cb26a60-2f8" badge="FREE - Value $97" data-id="element-2360" />
          </div>
          <div className="text-center bg-white p-4 md:p-6 rounded-xl border border-slate-200 max-w-2xl mx-auto shadow-sm" data-id="element-2361">
            <h4 className="font-bold text-slate-900 mb-2 flex items-center justify-center" data-id="element-2362">
              <Download className="w-4 h-4 mr-2 text-cyan-600" data-id="element-2363" />
              Una vez que descargues tu Lloyd:
            </h4>
            <p className="text-sm text-slate-600" data-id="element-2364">
              Abre HeyLloyd en tu computadora → Haz doble clic en el archivo del
              Lloyd → Espera unos segundos y verás cómo HeyLloyd comienza a
              guiarte.
            </p>
          </div>
        </div>
      </section>
      <DecisionGuide data-id="element-2365" />
      <FinalCTA data-id="element-2366" />

      {/* Footer */}
      <footer className="w-full relative z-10 bg-slate-900 border-t border-slate-800" data-id="element-2367">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-2368">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-2369">
            <p data-id="element-2370">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-2371">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-2372">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-2373">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-2374">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-2375">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-700" data-id="element-2376">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-2377">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-2378">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06B6D4] hover:text-[#0891b2] transition-colors" data-id="element-2379">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-2380">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2381">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-2382">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2383">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2384">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2385">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2386">
              <X className="w-6 h-6" data-id="element-2387" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2388">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2389">
              <p data-id="element-2390">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2391">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2392">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2393">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2394">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2395">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2396">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2397">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2398">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2399">
                5. Modificaciones
              </h3>
              <p data-id="element-2400">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2401">Contacto</h3>
              <p data-id="element-2402">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2403">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2404">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2405">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2406">
              <X className="w-6 h-6" data-id="element-2407" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2408">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2409">
              <p data-id="element-2410">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2411">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2412">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2413">
                <li data-id="element-2414">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2415">Información de registro del evento</li>
                <li data-id="element-2416">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2417">
                2. Uso de la Información
              </h3>
              <p data-id="element-2418">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2419">
                <li data-id="element-2420">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2421">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2422">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2423">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2424">
                3. Compartir Información
              </h3>
              <p data-id="element-2425">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2426">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2427">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2428">
                5. Tus Derechos
              </h3>
              <p data-id="element-2429">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2430">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2431">6. Cookies</h3>
              <p data-id="element-2432">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2433">Contacto</h3>
              <p data-id="element-2434">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2435">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}